/**
 * Detect iOS — iPhone, iPad, iPod, and iPadOS-on-Safari (which reports
 * Mac userAgent + maxTouchPoints > 1). SSR-safe: returns false when
 * `navigator` is undefined.
 */
export function isIos(): boolean {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent || ''
  const maxTouchPoints = (navigator as Navigator & { maxTouchPoints?: number }).maxTouchPoints ?? 0
  return /iPhone|iPad|iPod/.test(ua) || (/Mac/.test(ua) && maxTouchPoints > 1)
}

/** Already running as an installed PWA. SSR-safe. */
export function isStandalonePwa(): boolean {
  if (typeof window === 'undefined') return false
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true
  )
}
